import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import DashboardOverviewPanels from "./components/DashboardOverviewPanels";
import { useDisplayLocalization } from "../../../lib/datetime/DisplayLocalizationProvider";

function DashboardContent() {
  const { reload } = useDisplayLocalization();
  const queryClient = useQueryClient();
  const [profileSynced, setProfileSynced] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void reload()
      .then(async () => {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: ["customer-localization"] }),
          queryClient.invalidateQueries({ queryKey: ["dashboard-overview"] }),
        ]);
      })
      .finally(() => {
        if (!cancelled) {
          setProfileSynced(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [reload, queryClient]);

  return (
    <Box sx={{ py: 1 }}>
      {profileSynced ? (
        <DashboardOverviewPanels />
      ) : (
        <Paper
          elevation={0}
          sx={{ border: 1, borderColor: "divider", borderRadius: 1, mb: 3, py: 5 }}
        >
          <Stack alignItems="center" spacing={1}>
            <CircularProgress size={28} />
            <Typography variant="body2" color="text.secondary">
              Loading profile timezone…
            </Typography>
          </Stack>
        </Paper>
      )}
    </Box>
  );
}

export default DashboardContent;
